import { render } from "./ApproveManage.vue?vue&type=template&id=07153fd8&ts=true"
import script from "./ApproveManage.vue?vue&type=script&lang=tsx"
export * from "./ApproveManage.vue?vue&type=script&lang=tsx"

import "./ApproveManage.vue?vue&type=style&index=0&id=07153fd8&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__